(function(TIPTOE, window, document, $) {

	var options = {
			itemSelector: '.grid-item',
			percentPosition: true,
			stamp: '.stamp',
			layoutMode: 'masonry',
			columnWidth: '.grid-sizer',
		};

	/**
	 * Initialize the grid with isotope
	 */
	function gridInit() {
		console.log('gridInit');
		var $gridContainer = $('.js-masonry-grid');

		$gridContainer.masonry(options);

		// layout Isotope after each image loads
		$gridContainer.imagesLoaded().progress(function() {
			console.log('masonry relayout');
			setTimeout(function() {
				$gridContainer.masonry(options);
			}, 100);
		});
	}

	// Init the grid
	gridInit();

	$(window).on({
		resizeEnd: function() {
			$('.js-masonry-grid').masonry(options);
		},
		ajaxEnd: gridInit,
	});

	// Revalidate the isotope layout on
	// each lazyloaded image load
	$(TIPTOE).on('blazy:loaded', function() {
		setTimeout(function() {
			$('.js-masonry-grid').masonry(options);
		}, 200);
	});

	/* ================================
	* Filters
	* ================================ */

	var $categories = $('.js-categories');
	$categories.on('click', function(e) {
		$categories.not($(this)).removeClass('is-active');
		$(this).addClass('is-active');
	});
})(TIPTOE, window, document, jQuery);
